// extracted by mini-css-extract-plugin
module.exports = {"TrustedSlider":"TrustedSlider_TrustedSlider__mtyef","TrustedSlider__link":"TrustedSlider_TrustedSlider__link__umMIN"};